import { render, staticRenderFns } from "./light-topbar.vue?vue&type=template&id=e34830b0"
import script from "./light-topbar.vue?vue&type=script&lang=js"
export * from "./light-topbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports